import StyleSheet from '../../utils/helpers/styleSheet'
import {ImgUrl} from '../../models/editor/imgUrl'
import {ImgText} from '../../models/editor/imgText'
import BringForwardButton from './buttons/BringForwardButton'
import SendBackButton from './buttons/SendBackButton'
import MovementArrows from './MovementArrows'
import MirrorArrows from './MirrorArrows'
import ImgFilters from './ImgFilters'
import BrightnessController from './sliders/BrightnessController'
import RotationController from './sliders/RotationController'
import ScaleController from './sliders/ScaleController'
import ControlGroup from './ControlGroup'
import {useTranslation} from 'react-i18next'

const styles: StyleSheet = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    margin: '20px 20px',
  },
  imagesControls: {
    display: 'flex',
    flexDirection: 'row',
  },
  movementTools: {
    display: 'flex',
    flexDirection: 'row',
  },
}

interface PhotoProps {
  img: ImgUrl | ImgText
}

export default function Photo({img}: PhotoProps) {
  const {t} = useTranslation()
  return (
    <div style={styles.container}>
      <ControlGroup title={t('Sorrend')}>
        <div style={styles.imagesControls}>
          <SendBackButton />
          <BringForwardButton />
        </div>
      </ControlGroup>

      <ImgFilters img={img} />

      <BrightnessController img={img} />
      <ScaleController img={img} />
      <RotationController img={img} />

      <div style={styles.movementTools}>
        <MovementArrows img={img} />
        <MirrorArrows img={img} />
      </div>
    </div>
  )
}
